import { Color, DefaultValue, getShadow, Icon as IconComponent, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

import { ShortcutKey as ShortcutKeyComponent } from '../../../ShortcutKey'

export const GlobalSearchTipsWrapper = styled.div`
  width: 100%;
  padding: ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  position: absolute;
  top: calc(100% + ${Spacing.S8});
  left: 0;
  z-index: -1; /* we have to move it back to not cover search input with box shadow */
  background-color: ${Color.Black};
  ${getShadow('elevatedStrong')};
`

export const Header = styled.header`
  display: flex;
  margin-bottom: ${Spacing.S16};
`

export const TitleWrapper = styled.div`
  display: flex;
`

export const TitleIcon = styled(IconComponent)`
  margin-right: ${Spacing.S8};
`

export const Content = styled.div`
  margin-bottom: ${Spacing.S16};
`

export const Footer = styled.footer`
  padding-top: ${Spacing.S16};
  border-top: 1px solid ${transparentize(0.9, Color.White)};
`

export const ShortcutKey = styled(ShortcutKeyComponent)`
  background-color: ${transparentize(0.9, Color.White)};
`
